const libSubscribeNewbieGuide = {
  namespaced: true,
  state: {
    requests: {
      // 基础
      // restAccountUserTaskGradeGetUserTask // 获取任务状态
      // restAccountUserTaskGradeGetNextTask // 保存 跳过
      // 步骤a
      // websiteSearchSolrCompany, // 公司名联想
      // restAccountUserTaskGradeGetIndustryInfo // 获取行业信息
      // restAccountUserTaskGradeCoreKeyword // 获取核心关键词
      // 步骤g
      // restMpAuthWxUinfo, // 微信绑定状态
      // restMpAuthWxQrcode, // 微信二维码
      // restAccountSubscribeEmailPushPeriodAndAcceptMailBox, // 邮箱绑定状态
      // restAccountSubscribeEmailSendEmailVerifyCode, // 发送邮箱验证码
      // restAccountSubscribeEmailSaveEmail, // 绑定邮箱
      // subscribeGetUserDefaultRegion, // 获取用户默认地区范围
    }, // request集合
    // 用户信息
    userInfo: {},
    currentStepId: "", // a b c d e f g
    currentStep: 0, // 1 2 3 4 5 6 7 / 1 2 3 4 5
    totalSteps: null,
    keywords: "", // 字符串 ,分割
    keywordModulesFocusType: false,
    buryPointFn: null,
    configUrl: {},
  },
  getters: {
    requests: (state) => state.requests,
    userInfo: (state) => state.userInfo,
    currentStepId: (state) => state.currentStepId,
    currentStep: (state) => state.currentStep,
    totalSteps: (state) => state.totalSteps,
    keywords: (state) => state.keywords,
    keywordModulesFocusType: (state) => state.keywordModulesFocusType,
    buryPointFn: (state) => state.buryPointFn,
    configUrl: (state) => state.configUrl,
  },
  mutations: {
    updateRequests(state, requests) {
      state.requests = requests;
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    updateCurrentStepId(state, currentStepId) {
      state.currentStepId = currentStepId;
    },
    updateCurrentStep(state, currentStep) {
      state.currentStep = currentStep;
    },
    updateTotalSteps(state, totalSteps) {
      state.totalSteps = totalSteps;
    },
    updateKeywords(state, keywords) {
      state.keywords = keywords;
    },
    updatekeywordModulesFocusType(state, keywordModulesFocusType) {
      state.keywordModulesFocusType = keywordModulesFocusType;
    },
    updateburyPointFn(state, buryPointFn) {
      state.buryPointFn = buryPointFn;
    },
    updateconfigUrl(state, configUrl) {
      state.configUrl = configUrl;
    },
  },
  actions: {},
};
export default libSubscribeNewbieGuide;
